module.exports = __webpack_public_path__ + "img/icon_map_8_on_001.6e5740ef.png";